import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useChannelStateContext, useChatContext } from "stream-chat-react";
import { UserAuth } from "../Context";

import ProfilePicture from "../UserProfile/ProfilePicture";
export const ChannelHeader = ({ setIsChatOpen }) => {
  const { user } = UserAuth();
  const { channel } = useChannelStateContext();
  console.log("channel", channel);
  const [channelUsers, setChannelUsers] = useState([]);
  const { client } = useChatContext();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Check if a given string exists in the names of the channel members
  const doesNameExistInChannelMembers = (name) => {
    if (!channel?.state) return false;
    return Object.values(channel.state.members).some((member) =>
      member.user.name.includes(name)
    );
  };
  // Update the list of channel users dynamically
  useEffect(() => {
    const updateChannelUsers = (event) => {
      if (!client) return;
      if (!channel?.state) return;

      setChannelUsers(
        Object.values(channel.state.members).map((member) => ({
          id: member.user_id,
          name: member.user.name || "Unknown User",
          online: member.user.online || false,
          photo: member.user.image || "", // Assuming avatars are available
        }))
      );
    };

    // Initial update
    updateChannelUsers();
    // console.log(doesNameExistInChannelMembers("Asad"));

    // Listen for real-time presence changes
    client.on("user.presence.changed", updateChannelUsers);

    // Cleanup listener on unmount
    return () => {
      client.off("user.presence.changed", updateChannelUsers);
    };
  }, [channel, client]);

  if (!channel || !user) {
    return null;
  }

  return (
    <div className="d-flex justify-content-start align-items-center px-1 py-2 p-lg-3 border-bottom bg-mode">
      <button
        onClick={() => setIsChatOpen(false)}
        className="btn me-2 p-1 d-md-none"
      >
        <i className="fa-solid fa-arrow-left"></i>
      </button>
      {channel.type === "messaging" && channelUsers.length === 2 ? (
        // Private messaging channel with two members
        <Link
          to={`/userProfile/${
            channelUsers.find((member) => member.id !== user?.uid)?.id
          }`}
          className="d-flex align-items-center gap-2"
        >
          <div className="flex-shrink-0">
            <img
              src={
                channelUsers.find((member) => member.id !== user?.uid)?.photo
              }
              style={{
                width: isSmallScreen ? "40px" : "50px",
                height: isSmallScreen ? "40px" : "50px",
                borderRadius: "8px",
                objectFit: "cover",
                objectPosition: "top",
              }}
              width={isSmallScreen ? "40px" : "50px"}
              height={isSmallScreen ? "40px" : "50px"}
              alt=""
            />
          </div>
          <div className="d-flex flex-column">
            <div
              className="text-truncate"
              style={{
                fontWeight: 600,
                fontSize: isSmallScreen ? "16px" : "18px",
                color: "black",
                width: "100%",
              }}
            >
              {channelUsers.find((member) => member.id !== user?.uid)?.name ||
                "User"}
            </div>
            <div
              style={{
                fontStyle: "italic",
                fontSize: isSmallScreen ? "14px" : "16px",
                fontWeight: 400,
                color: "#676A79 ",
                lineHeight: "120%",
              }}
              className="d-flex align-items-center gap-1"
            >
              <i
                className={`fa-solid fa-circle ${
                  channelUsers.find((member) => member.id !== user?.uid)?.online
                    ? "text-success"
                    : "text-muted"
                }`}
              ></i>
              {channelUsers.find((member) => member.id !== user?.uid)?.online
                ? "Online"
                : "Offline"}
            </div>
          </div>
          {/* <div className="d-block ps-2">
            <h6 className="mb-0 mt-1">
              {channelUsers.find((member) => member.id !== user?.uid)?.name ||
                "User"}
            </h6>
            <h6 className="mb-0 fw-light">
              <i
                className={`fa-solid fa-circle ${
                  channelUsers.find((member) => member.id !== user?.uid)?.online
                    ? "text-success"
                    : "text-muted"
                } me-1`}
              ></i>
              {channelUsers.find((member) => member.id !== user?.uid)?.online
                ? "Online"
                : "Offline"}
            </h6>
          </div> */}
        </Link>
      ) : (
        <div className="d-flex align-items-center">
          <div className="flex-shrink-0 avatar-sm me-2">
            <ProfilePicture userData={{ userName: channel.data.name }} />
          </div>
          <div className="d-flex flex-column">
            <div
              style={{
                fontWeight: 600,
                fontSize: isSmallScreen ? "16px" : "18px",
              }}
              className="d-flex align-items-center gap-1"
            >
              <div
                className="text-truncate"
                style={{ maxWidth: isSmallScreen ? "100px" : "150px" }}
              >
                {channel.data.name || "Group Chat"}
              </div>
              <span style={{ fontWeight: 400 }}>by</span>
              <div style={{ whiteSpace: "nowrap" }}>
                {channel.data.created_by.name
                  .split(" ")
                  .slice(0, 2)
                  .join(" ")}
              </div>
            </div>
            <div
              style={{
                fontStyle: "italic",
                fontSize: isSmallScreen ? "14px" : "16px",
                fontWeight: 400,
                color: "#676A79 ",
                lineHeight: "120%",
              }}
            >
              {channelUsers
                .map((member) => member.name.split(" ")[0])
                .join(", ")}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
